module.exports = __webpack_public_path__ + "static/blurry_tree-c6f82b39df978aa6a1bd279863dc4653.png";